import PurchasePricePage from "./PurchasePricePage"

export default PurchasePricePage
